import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import VisualStoryItem from "./VisualStoryItem";
import CustomSlider from "../../atoms/CustomSlider";

import { componentProps } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./visual-stories.m.css";

const VisualStories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [], autoPlay, showDots, numberOfStoriesShow = 9 } = componentProps(collection);

  const { desktop } = useDevice();

  return (
    <ComponentContainer titleClass="visual-story-header" styleName="base" collection={collection}>
      <CustomSlider
        isNavigation={desktop && numberOfStoriesShow >= 6}
        isPagination={showDots}
        isAutoplay={autoPlay}
        isNoPaddingMobile={true}
        hideDisableIcon={true}
        interval={3000}
        slidesPerView={{ mobileSlides: 2.5, tabSlides: 4.4, desktopSlides: 5.4 }}
        spacing={{ mobileSpace: 8, tabSpace: 16, desktopSpace: 16 }}
      >
        {items.slice(0, numberOfStoriesShow).map(({ story }, index) => (
          <VisualStoryItem key={index} story={story} index={index + 1} />
        ))}
      </CustomSlider>
    </ComponentContainer>
  );
};

VisualStories.propTypes = {
  collection: object,
};

VisualStories.storyLimit = 12;

export default VisualStories;
